import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";

const overviewSurfaceVariants = cva("app-overview-surface", {
  variants: {
    frame: {
      card: "app-overview-surface--card",
      topBorder: "app-overview-surface--top-border",
      none: "app-overview-surface--frameless",
    },
    grow: {
      true: "flex flex-1 flex-col",
      false: "",
    },
  },
  defaultVariants: {
    frame: "card",
    grow: false,
  },
});

type OverviewSurfaceProps = HTMLAttributes<HTMLElement> &
  VariantProps<typeof overviewSurfaceVariants> & {
    as?: "div" | "section";
  };

export function OverviewSurface({
  as: Component = "div",
  className,
  frame,
  grow,
  ...props
}: OverviewSurfaceProps) {
  return (
    <Component
      className={cn(overviewSurfaceVariants({ frame, grow }), className)}
      {...props}
    />
  );
}
